import Head from 'next/head';

interface StructuredDataProps {
  data: object | object[];
}

const StructuredData: React.FC<StructuredDataProps> = ({ data }) => {
  const jsonLd = Array.isArray(data) ? data : [data];

  return (
    <Head>
      {jsonLd.map((item, index) => (
        <script
          key={index}
          type="application/ld+json"
          // JSON.stringify doesn't escape "</script>" - a field containing
          // that literal string could break out of the script tag and
          // inject arbitrary markup/script into the page.
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(item).replace(/</g, '\\u003c')
          }}
        />
      ))}
    </Head>
  );
};

export default StructuredData;

